import { regionTypeOptions } from "@api/throughShipment/throughShipmentApi";
import { dealerState, fetchRetailList, fetchRetailRegion } from "@redux/dealerSlice";
import { supplyChainState, updateRetailerFilter } from "@redux/supplyChainSlice";
import { AutoComplete, Button, Col, Form, FormProps, Row, Select } from "antd";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SupplyChainFilterParam } from "@api/supplyChainApi";
import styled from "styled-components";

const Wrapper = styled(Form as React.ComponentType<FormProps<Partial<SupplyChainFilterParam>>>)<{ isVisible: boolean }>`
  padding: 0px 16px 20px 16px;
  display: ${({ isVisible }) => (isVisible ? "block" : "none")};
`;
const CustomButton = styled(Button)`
  margin-right: 10px;
`;

type Props = {
  isVisible: boolean;
};

export default function RetailerFilter(props: Props) {
  const { isVisible } = props;

  const dispatch = useDispatch();
  const { retailRegion, retailList } = useSelector(dealerState);
  const { supplyChainRetailerFilter } = useSelector(supplyChainState);

  const [form] = Form.useForm();
  const selectedType = Form.useWatch("type", form);

  useEffect(() => {
    dispatch(fetchRetailList({ regionTypes: selectedType }));
  }, [dispatch, selectedType]);

  const onReset = () => {
    form.resetFields();
    dispatch(
      updateRetailerFilter({
        limit: supplyChainRetailerFilter.limit,
        offset: 0,
        type: undefined,
        region: undefined,
        name: undefined,
      }),
    );
  };

  const onSubmit = (values: Partial<SupplyChainFilterParam>) => {
    dispatch(
      updateRetailerFilter({
        ...values,
        limit: supplyChainRetailerFilter.limit,
        offset: 0,
      }),
    );
  };

  useEffect(() => {
    dispatch(fetchRetailRegion({}));
  }, [dispatch]);

  const options = retailList.results.map((item) => {
    return { value: item.name, label: item.name };
  });

  const regionOptions = retailRegion.results.map((item) => {
    return { value: item.name, label: item.name };
  });

  return (
    <Wrapper
      colon={false}
      labelAlign="left"
      labelCol={{ span: 8 }}
      form={form}
      isVisible={isVisible}
      initialValues={{}}
      onFinish={onSubmit}
    >
      <Row gutter={40}>
        <Col span={7}>
          <Form.Item label="合作通路類型" name="type" wrapperCol={{ span: 16 }}>
            <Select options={regionTypeOptions} />
          </Form.Item>
        </Col>
        <Col span={7}>
          <Form.Item label="通路名稱" name="name" wrapperCol={{ span: 18 }}>
            <AutoComplete
              allowClear
              options={options}
              placeholder="請選擇"
              filterOption={(inputValue, option) =>
                option!.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
              }
            />
          </Form.Item>
        </Col>
        <Col span={7}>
          <Form.Item label="地區" name="region" wrapperCol={{ span: 18 }}>
            <Select options={regionOptions} placeholder="請選擇" />
          </Form.Item>
        </Col>
      </Row>
      <Row justify="end">
        <CustomButton onClick={onReset}>清除篩選條件</CustomButton>
        <Button type="primary" htmlType="submit">
          套用
        </Button>
      </Row>
    </Wrapper>
  );
}
